const AgentIndex = () => import(/* webpackChunkName: "haierAgent" */ '../../haierProduct/components/spcleqpt/index')
// 投保详情
const AgentSpcleqptDetail = () => import(/* webpackChunkName: "haierAgent" */ '../../haierProduct/components/spcleqpt/detail')
// 批改单
const AgentReview = () => import(/* webpackChunkName: "haierAgent" */ '../../haierProduct/components/spcleqpt/review/index')
const AgentReviewDetail = () => import(/* webpackChunkName: "haierAgent" */ '../../haierProduct/components/spcleqpt/review/detail')
// 特种设备第三者责任险
const AgentSpcleqptAlyone = () => import(/* webpackChunkName: "haierAgent" */ '../../haierProduct/components/spcleqpt/alyone')

export default [
	{
		path:'',
		component:AgentIndex,
	},
	{
		path:'spcleqpt-alyone/:id?',
		name:'spcleqpt-alyone',
		component:AgentSpcleqptAlyone,
	},
    // 批改单
	{
		path:'review/:id?',
		name:'review',
		component:AgentReview,
	},
	{
		path:'review/detail/:id?',
		name:'review-detail',
		component:AgentReviewDetail,
	},
    {
		path:'detail/:id?',
		name:'spcleqpt-detail',
		component:AgentSpcleqptDetail,
	},
    
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/spcleqpt.js